export const UPDATE_MEMBER = 'UPDATE_MEMBER';
export const GET_MEMBERSHIP_TYPE = 'GET_MEMBERSHIP_TYPE';
